<template>
  <avz-apls />
</template>

<script>
import APLs from '@/components/APLs'

export default {
  components: {
    'avz-apls': APLs
  }
}
</script>
